import { observer } from 'mobx-react-lite'
import { ChooseNumberCommon } from 'pages/settings/ui/ChooseNumberCommon/ChooseNumberCommon'
import { useNewInboxStepsContext } from 'pages/settings/pages/inboxes/pages/newInbox/context/newInboxStepsContext'

export const ChooseNumber = observer(() => {
  const {
    chooseNumberStore: {
      chooseNumberTabsStore,
      useCases,
      selectedUseCaseId,
      nextDisabled,
      setUseCase,
      nextClick,
    },
  } = useNewInboxStepsContext()

  return (
    <ChooseNumberCommon
      chooseNumberTabsStore={chooseNumberTabsStore}
      useCases={useCases}
      selectedUseCaseId={selectedUseCaseId}
      nextDisabled={nextDisabled}
      setUseCase={setUseCase}
      nextClick={nextClick}
    />
  )
})
